export const FEATURE_CONTEXT = {
  SUPPLIER_TEMPLATE: 'SUPPLIER_TEMPLATE',
  REDISTRIBUTION_SUPPLIER_TEMPLATE: 'REDISTRIBUTION_SUPPLIER_TEMPLATE',
  WHEEL_SUPPLIER_TEMPLATE: 'WHEEL_SUPPLIER_TEMPLATE',
  BRAND_TEMPLATE: 'BRAND_TEMPLATE',
  SETTING_TEMPLATE: 'SETTING_TEMPLATE',
  QUOTE_BRAND_TEMPLATE: 'QUOTE_BRAND_TEMPLATE',
  REDISTRIBUTION_BRAND_TEMPLATE: 'REDISTRIBUTION_BRAND_TEMPLATE',
  CUSTOMERS_REDISTRIBUTION_PRICING_POLICY:
    'CUSTOMERS_REDISTRIBUTION_PRICING_POLICY',
  ADVERT: 'ADVERT',
  REDISTRIBUTION_PRICING_POLICY_BRANDS: 'REDISTRIBUTION_PRICING_POLICY_BRANDS',
  QUOTE_PRICING_POLICY_BRANDS: 'QUOTE_PRICING_POLICY_BRANDS',
} as const;
